module.exports = __webpack_public_path__ + "assets/img/complaint_state_2.4dd12921.svg";